import SquaredButtonComponent from './SquaredButtonComponent'

export default SquaredButtonComponent
